import { Box, Button, ButtonAppearance, ButtonSize, FormControl, Text, TextArea, TextField } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const NonCatalogItemStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 100%;
`;
export const ModalHeaderStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})<{ isDispatchModule: boolean }>`
  margin: 0;
  ${({ theme, isDispatchModule }) => css`
    padding: ${isDispatchModule ? theme.spacings[500] : theme.spacings[200]};
    background-color: ${({ theme }) => (isDispatchModule ? theme.colors.primary[700] : theme.colors.grey[100])};
    border-bottom: 1px solid ${({ theme }) => theme.colors.blue[200]};
  `}
`;
export const TextAreaStyled = styled(TextArea)`
  ${({ theme }) => css`
    padding: ${theme.spacings[400]} ${theme.spacings[400]} ${theme.spacings[500]};
  `}
`;
export const TextFieldStyled = styled(TextField)`
  ${({ theme }) => css`
    padding-left: ${theme.spacings[400]};
    &::placeholder {
      color: ${({ theme }) => theme.colors.grey[300]};
    }
  `}
`;
export const FooterStyled = styled(Box).attrs({
  justifyContent: { sm: 'flex-start' },
})`
  width: 100%;
`;
export const FooterButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.PRIMARY,
  size: ButtonSize.SMALL,
})`
  ${({ theme }) => css`
    min-width: 96px;
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.white};
    padding: ${theme.spacings[500]};
  `}
`;

export const FormItemStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  pt: { sm: '600' },
  px: { sm: '400' },
})`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[400]};
    color: ${theme.colors.grey[700]};
  `}
`;

export const FormControlStyled = styled(FormControl)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.blue[800]};
    border-radius: ${theme.spacings[200]};
  `}
`;
export const UomListStyled = styled(Box)`
  ${({ theme }) => css`
    width: 174px;
    border: 1px solid ${theme.colors.grey[300]};
    height: 36px;
    margin-left: ${theme.spacings[400]};
    borderradius: ${theme.spacings[200]};
  `}
`;
export const FormTextStyled = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.grey[500]};
    padding: ${theme.spacings[300]};
    font-size: ${theme.fontSizes[300]};
  `}
`;
